export default __webpack_public_path__ + "static/media/message_icon.f24dbf8a.svg";